import { getRequest } from 'utils/api/apiRequest'

type VoucherStatus = {
  downloaded_at: string | null
}

export const getVoucherStatus = (token: string) => getRequest<VoucherStatus>(`/vouchers/${token}/status`)
